import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseTileData } from "../base-tile/base-tile.component";
import { NgxMaskService } from "ngx-mask";
import { timer } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { AssessmentTileData } from "../../models/assessment.model";
import { ScheduleService } from '../../services/schedule.service';
import { ViewAsService } from '../../services/view-as.service';

@Component({
  selector: 'app-assessment-tile',
  templateUrl: './assessment-tile.component.html',
  styleUrls: ['./assessment-tile.component.scss']
})
export class AssessmentTileComponent implements OnInit {

  @Input() document!: AssessmentTileData;
  @Input() showDocType = false;

  @Output() tileClick = new EventEmitter<AssessmentTileData>();
  @Output() deleteAssessment = new EventEmitter<AssessmentTileData>();
  data!: BaseTileData;

  reverseTimeOrder$ = timer(1000).pipe(
      startWith(0),
      map(_ => {
        return this.document.endTime.getTime() < Date.now();
      })
  );
  startTitle$ = timer(1000).pipe(
      startWith(0),
      map(_ => {
        return this.document.startTime.getTime() < Date.now() ? 'Started' : 'Starts';
      })
  );
  endTitle$ = timer(1000).pipe(
      startWith(0),
      map(_ => {
        return this.document.endTime.getTime() < Date.now() ? 'Ended' : 'Ends';
      })
  );

  showOwner$ = this.viewAsService.selectedUsers$.pipe(map(users => users === 'All' || users.length > 1));
  readonly$ = this.viewAsService.readonly$;

  currentStatusFilter$ = this.scheduleService.filterAssessmentStatus$;

  label!: string;
  labelColor!: 'red' | 'yellow' | 'green';

  readonly timeFormat = 'hh:mm a';

  constructor(
      private maskService: NgxMaskService,
      private scheduleService: ScheduleService,
      private viewAsService: ViewAsService,
  ) {}

  refreshData() {
    const phoneNumber = this.maskService.applyMask(this.document.phoneNumber, '(000) 000-0000');
    this.data = {
      title: this.document.firstName + ' ' + this.document.lastName,
      subtitle: phoneNumber,
      description: this.document.jobType
    };
    this.setLabel();
    this.setLabelColor();
  }

  isCompleted() {
    return this.document.status === 'submitted' && (this.document.estimateId || this.document.jobId || this.document.invoiceId);
  }

  setLabel() {
    if(this.showDocType) {
      this.label = 'Assessment';
      return;
    }
    if (this.document.status === 'canceled')
      this.label = 'Canceled';
    else if (this.document.status === 'submitted' && this.isCompleted())
      this.label = 'Completed';
    else
      this.label = 'Submitted';
  }

  setLabelColor() {
    if (this.document.status === 'submitted' && this.isCompleted()) {
      this.labelColor = 'green';
      return;
    }
    this.labelColor = {
      canceled: 'red',
      submitted: 'yellow',
    }[this.document.status] as 'red' | 'yellow';
  }

  ngOnInit() {
    this.refreshData();
  }

  async onDeleteClick(event: Event) {
    event.stopPropagation();
    this.deleteAssessment.emit(this.document);
  }
}
